import type {ReactElement} from 'react';

import {Button} from '@/components';
import {BlockUserModal} from '@/components/common/BlockUserModal';
import type {AdminAfriexPerson} from '@/types';

import useBlockUser from './useBlockUser';

type BlockUserProps = {
  user: AdminAfriexPerson;
};

const BlockUser = ({user}: BlockUserProps): ReactElement => {
  const {
    isLoading,
    showModal,
    toggleModal,
    securityNoteInput,
    handleSecurityNoteChange,
    handleBlockUser,
    handleBlockReason,
    blockReason,
    unblockReason,
    handleUnblockReason,
  } = useBlockUser(user);

  return (
    <>
      {showModal ? (
        <BlockUserModal
          isOpen={showModal}
          onClose={toggleModal}
          user={user}
          isLoading={isLoading}
          onSubmit={handleBlockUser}
          securityNote={securityNoteInput || ''}
          handleBlockReason={handleBlockReason}
          blockReason={blockReason || ''}
          handleSecurityNoteChange={handleSecurityNoteChange}
          handleUnblockReason={handleUnblockReason}
          unblockReason={unblockReason || ''}
        />
      ) : (
        <Button
          colorScheme={user.isSecurityFlagged ? 'orange' : 'red'}
          onClick={toggleModal}
          className="w-fit"
        >
          {user.isSecurityFlagged ? 'Unblock ' : 'Block '}
          {user?.name?.firstName}
        </Button>
      )}
    </>
  );
};

export default BlockUser;
